import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-xhr-backend';
import LngDetector from 'i18next-browser-languagedetector';

if (initReactI18next) {
    i18n
        .use(Backend)
        .use(initReactI18next)
        .use(LngDetector)
        .init({
            react: { 
                useSuspense: false,
                wait: true
            },
            debug: false,
            fallbackLng: 'en'
        
        });
}

export default i18n;
